import React from 'react';
import { useSelector } from 'react-redux';

import { useCampaignDetail } from '../CampaignDetailProvider';
import LabelItem from '../Labelling/LabelItem';

const LabelTypeSelect = () => {
  const { labels } = useSelector((s) => s.socialListening);
  const { selectedLabels, setNewLabels } = useCampaignDetail();

  return (
    <div className="filter-select-container">
      <div className="filter-options-container">
        <div className="sl-label-filter-container">
          {labels.map((label) => {
            const isSelected = Boolean(selectedLabels?.find?.((l) => l._id === label._id));
            return (
              <LabelItem
                key={label._id}
                checked={isSelected}
                onClick={() => {
                  if (isSelected) setNewLabels(selectedLabels?.filter((l) => l._id !== label._id));
                  else setNewLabels(Array.isArray(selectedLabels) ? [...selectedLabels, label] : [label]);
                }}
                color={label.color}
                title={label.title}
                size="sm"
              />
            );
          })}
        </div>
      </div>
      <div className="sl-does-not-contain-label-container">
        <LabelItem
          checked={selectedLabels === -1}
          onClick={() => {
            if (selectedLabels === -1) {
              setNewLabels([]);
            } else {
              setNewLabels(-1);
            }
          }}
          color="var(--border-default)"
          title="Doesn't Contain Label"
          size="sm"
        />
      </div>
    </div>
  );
};

export default LabelTypeSelect;
